(() => {
  'use strict';
  const host = document.querySelector('[data-casebang-studio-host]');
  // The floating entry is optional; menus use the public controller below.
  const entry = document.querySelector('.casebang-studio-test-entry[data-casebang-studio-open],.casebang-halloween-studio__open[data-casebang-studio-open]');
  if (!host || host.dataset.controllerReady) return;
  host.dataset.controllerReady = 'true';
  document.body.append(host);
  const template = host.querySelector('[data-studio-template]');
  const loading = host.querySelector('[data-studio-loading]');
  const message = host.querySelector('[data-studio-message]');
  const loadingText = message.textContent;
  let root, instance, mounting, runtimeLoad, context, saved, cartPresentation, opening, entryHidden, opened = false;
  const cart = () => document.querySelector('cart-drawer');
  const cartOpen = () => cart()?.classList.contains('active') || document.body.classList.contains('cart_active');
  // Loloyal mounts its delayed subscription dialog in open Shadow DOM, outside
  // Studio. Exempt only its popup carrier, never the loyalty launcher or page.
  const subscriptionRoot = () => document.getElementById('loloyal-core-popup-root');
  let subscription, subscriptionFocus, subscriptionObserver;
  const subscriptionShadows = new Set();
  function subscriptionPopup() {
    for (const node of subscriptionRoot()?.querySelectorAll('.loloyal-shadowdom-container') || []) {
      const popup = node.shadowRoot?.querySelector('.loloyal-core-popup-overlay.visible,.loloyal-core-popup-overlay.closing');
      if (popup) return popup;
    }
    return null;
  }
  function focusControls(scope) {
    return [...scope.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(node => node.getClientRects().length && !node.closest('[hidden],[inert]'));
  }
  function focusSubscription(popup) {
    (focusControls(popup)[0] || popup.querySelector('.loloyal-core-popup-close-btn-container'))?.focus({preventScroll:true});
  }
  function syncSubscription() {
    if (!opened) return;
    const container = subscriptionRoot();
    if (container && !subscriptionShadows.has(container)) {
      subscriptionShadows.add(container);
      subscriptionObserver.observe(container,{childList:true,subtree:true});
    }
    for (const node of container?.querySelectorAll('.loloyal-shadowdom-container') || []) {
      if (node.shadowRoot && !subscriptionShadows.has(node.shadowRoot)) {
        subscriptionShadows.add(node.shadowRoot);
        subscriptionObserver.observe(node.shadowRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
      }
    }
    const popup = subscriptionPopup();
    if (popup === subscription) return;
    if (popup) {
      if (!subscription) subscriptionFocus = document.activeElement;
      subscription = popup;
      focusSubscription(popup);
    } else {
      subscription = null;
      if (subscriptionFocus) {
        const focus = subscriptionFocus; subscriptionFocus = null;
        (focus.isConnected && !focus.closest('[inert]') ? focus : host).focus({preventScroll:true});
      }
    }
  }
  function watchSubscription() {
    subscriptionObserver = new MutationObserver(() => {
      syncSubscription();
      // React attaches the Shadow Root in its effect after inserting the host.
      requestAnimationFrame(syncSubscription);
    });
    subscriptionObserver.observe(document.body,{childList:true});
    syncSubscription();
  }
  function restoreCartPresentation() {
    if (!cartPresentation) return;
    const {header,marker,top,priority} = cartPresentation; cartPresentation = null;
    if (marker === null) header.removeAttribute('data-studio-cart-header'); else header.setAttribute('data-studio-cart-header',marker);
    if (top) document.body.style.setProperty('--cb-studio-cart-top',top,priority); else document.body.style.removeProperty('--cb-studio-cart-top');
    delete document.body.dataset.casebangStudioCartOpen;
  }
  function syncCartPresentation() {
    if (!opened || !cartOpen()) { restoreCartPresentation(); return; }
    if (!cartPresentation) {
      const header = document.querySelector('body > .section-header');
      if (!header) return;
      const detached = getComputedStyle(header).display === 'none';
      cartPresentation = {header,marker:header.getAttribute('data-studio-cart-header'),top:document.body.style.getPropertyValue('--cb-studio-cart-top'),priority:document.body.style.getPropertyPriority('--cb-studio-cart-top')};
      header.dataset.studioCartHeader = detached ? 'detached' : 'present';
      document.body.dataset.casebangStudioCartOpen = 'true';
    }
    // Read the real theme navigation once on open/resize, never on Builder render.
    const bottom = cartPresentation.header.getBoundingClientRect().bottom;
    document.body.style.setProperty('--cb-studio-cart-top',`${Math.max(0,Math.min(bottom,innerHeight))}px`);
  }
  function loadRuntime() {
    if (window.CasebangBuilderRuntime) return Promise.resolve(window.CasebangBuilderRuntime);
    if (runtimeLoad) return runtimeLoad;
    runtimeLoad = new Promise((resolve,reject) => {
      const url = new URL(host.dataset.runtimeUrl,location.href).href;
      let script = [...document.scripts].find(node => node.src === url);
      const existing = Boolean(script);
      if (!script) { script = document.createElement('script'); script.src = url; script.async = true; }
      let timer;
      const finish = error => {
        clearTimeout(timer); script.removeEventListener('load',loaded); script.removeEventListener('error',failed);
        if (error) { runtimeLoad = null; if (!existing) script.remove(); reject(error); }
        else resolve(window.CasebangBuilderRuntime);
      };
      const loaded = () => finish(window.CasebangBuilderRuntime ? null : new Error('Studio runtime unavailable'));
      const failed = () => finish(new Error('Studio runtime load failed'));
      script.addEventListener('load',loaded,{once:true}); script.addEventListener('error',failed,{once:true});
      timer = setTimeout(failed,15000);
      if (!existing) document.head.append(script);
      if (window.CasebangBuilderRuntime) loaded();
    });
    return runtimeLoad;
  }
  function lockPage(returnFocus) {
    const html = document.documentElement, body = document.body;
    const saved = {x:scrollX,y:scrollY,focus:returnFocus instanceof HTMLElement ? returnFocus : document.activeElement,htmlOverflow:html.style.overflow,htmlGutter:html.style.scrollbarGutter,bodyOverflow:body.style.overflow,inert:[]};
    if (innerWidth - html.clientWidth > 0) html.style.scrollbarGutter = 'stable';
    // Lock the viewport without making body a new sticky containing block.
    // Changing body overflow moves the theme's sticky header on scrolled pages.
    html.style.overflow = 'hidden';
    for (const node of body.children) {
      // Cart is the existing body-level theme component, never a second drawer.
      if (node === host || node === subscriptionRoot() || node.tagName === 'CART-DRAWER' || ['SCRIPT','STYLE','LINK'].includes(node.tagName)) continue;
      saved.inert.push([node,node.inert]); node.inert = true;
    }
    return saved;
  }
  function restorePage() {
    if (!saved) return;
    const before = saved; saved = null;
    for (const [node,inert] of before.inert) node.inert = inert;
    document.body.style.overflow = before.bodyOverflow;
    document.documentElement.style.overflow = before.htmlOverflow;
    document.documentElement.style.scrollbarGutter = before.htmlGutter;
    window.scrollTo({left:before.x,top:before.y,behavior:'instant'});
    const focus = [before.focus,entry].find(node => node?.isConnected && !node.closest('[hidden],[inert]') && node.getClientRects().length);
    (focus || document.body).focus({preventScroll:true});
  }
  function closeStudio() {
    if (!opened) return;
    if (cartOpen()) cart()?.close?.();
    restoreCartPresentation();
    window.CasebangBuilderRuntime?.activateStudio(root,false);
    opened = false; host.hidden = true;
    if (entry) entry.hidden = entryHidden;
    subscriptionObserver?.disconnect(); subscriptionShadows.clear();
    subscription = null; subscriptionFocus = null;
    delete document.body.dataset.casebangStudioOpen;
    restorePage();
  }
  function openStudio(options = {}) {
    if (opened) return opening || Promise.resolve(Boolean(instance));
    opened = true; saved = lockPage(options?.returnFocus);
    if (entry) { entryHidden = entry.hidden; entry.hidden = true; }
    host.hidden = false; document.body.dataset.casebangStudioOpen = 'true';
    host.focus({preventScroll:true});
    watchSubscription();
    // Reopening during bootstrap reuses the same pending mount and promise.
    if (opening) return opening;
    opening = prepareStudio().finally(() => { opening = null; });
    return opening;
  }
  async function prepareStudio() {
    const key = JSON.stringify([host.dataset.country,host.dataset.locale]);
    if (context !== key && !mounting) {
      instance?.destroy(); root?.remove(); instance = null;
      root = template.content.firstElementChild.cloneNode(true);
      root.dataset.country = host.dataset.country; root.dataset.locale = host.dataset.locale;
      host.append(root); context = key;
    }
    loading.hidden = Boolean(instance); message.textContent = loadingText;
    try {
      const runtime = await loadRuntime();
      runtime.activateStudio(root,opened);
      if (!mounting && !instance) mounting = runtime.mountStudio(root);
      if (mounting) instance = await mounting;
      mounting = null; loading.hidden = true;
      // Closing during bootstrap must never resurrect the overlay or take focus.
      runtime.activateStudio(root,opened);
      if (opened) {
        (root.querySelector('[data-advanced-exit]') || host).focus({preventScroll:true});
      }
      return opened;
    } catch (error) {
      console.error('[CASEBANG Studio]',error);
      mounting = null; loading.hidden = false;
      message.textContent = root ? JSON.parse(root.querySelector('[data-cb-builder-labels]').textContent).unable_to_load : loadingText;
      if (opened) host.querySelector('[data-studio-dismiss]').focus({preventScroll:true});
      return false;
    }
  }
  // Delegation supports multiple static or dynamically rendered launch buttons.
  // Menus must close using their own lifecycle before calling the public API.
  document.addEventListener('click',event => {
    const trigger = event.target instanceof Element ? event.target.closest('button[data-casebang-studio-open],a[data-casebang-studio-open]') : null;
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); openStudio({returnFocus:trigger});
  });
  // Compatibility with the target theme's existing Studio launch event.
  document.addEventListener('casebang:studio-open',event => requestAnimationFrame(() => openStudio(event.detail)));
  host.addEventListener('casebang:studio-close',closeStudio);
  host.querySelector('[data-studio-dismiss]').addEventListener('click',closeStudio);
  if (cart()) new MutationObserver(() => {
    syncCartPresentation();
    if (opened && cartOpen() && !cart().contains(document.activeElement)) cart().querySelector('.drawer__close')?.focus({preventScroll:true});
  }).observe(cart(),{attributes:true,attributeFilter:['class']});
  if (document.querySelector('body > .section-header')) new ResizeObserver(() => {
    if (opened && cartOpen()) syncCartPresentation();
  }).observe(document.querySelector('body > .section-header'));
  document.addEventListener('keydown',event => {
    if (!opened) return;
    const popup = subscriptionPopup();
    if (event.key === 'Escape') {
      event.preventDefault(); event.stopImmediatePropagation();
      if (popup) {
        if (!popup.classList.contains('closing')) popup.querySelector('.loloyal-core-popup-close-btn-container')?.click();
      }
      else if (cartOpen()) cart()?.close?.();
      else if (instance?.pickerOpen) instance.closeDevicePicker();
      else if (instance?.state.drawerOpen || instance?.drawer.closing) instance.closeDrawer(true);
      else closeStudio();
      return;
    }
    if (event.key !== 'Tab') return;
    const scope = popup || (cartOpen() ? cart() : instance?.pickerOpen ? root.querySelector('[data-device-picker]') : instance?.state.drawerOpen ? root.querySelector('[data-drawer]') : host);
    const controls = focusControls(scope);
    const active = popup ? popup.getRootNode().activeElement : document.activeElement;
    const first = controls[0], last = controls.at(-1);
    if (!first) { event.preventDefault(); host.focus({preventScroll:true}); }
    else if (event.shiftKey && (active === first || !controls.includes(active))) { event.preventDefault(); last.focus({preventScroll:true}); }
    else if (!event.shiftKey && (active === last || !controls.includes(active))) { event.preventDefault(); first.focus({preventScroll:true}); }
  },true);
  document.addEventListener('focusin',event => {
    const popup = opened && subscriptionPopup();
    if (popup) {
      if (!event.composedPath().includes(popup)) focusSubscription(popup);
      return;
    }
    if (opened && !host.contains(event.target) && !(cartOpen() && cart()?.contains(event.target))) host.focus({preventScroll:true});
  });
  window.CasebangStudio = Object.freeze({
    version: 1,
    open: openStudio,
    close: closeStudio,
    getState: () => ({isOpen:opened,isReady:Boolean(instance),isLoading:Boolean(opening)})
  });
  document.dispatchEvent(new CustomEvent('casebang:studio-ready',{detail:{api:window.CasebangStudio}}));
})();
